import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { STATUS_TABS } from './statusTabsConfig';

const HpsStatusTabs = ({ activeTab, onChange, isLoading = false }) => (
  <Nav tabs className='nav-tabs-custom nav-primary mb-0'>
    {STATUS_TABS.map(tab => (
      <NavItem key={tab.id}>
        <NavLink
          tag='button'
          type='button'
          className={classnames('cursor-pointer', {
            active: activeTab === tab.id,
          })}
          onClick={() => !isLoading && onChange?.(tab.id)}
        >
          <i className={`${tab.icon} align-middle me-1`}></i>
          <span className='fw-semibold'>{tab.label}</span>
        </NavLink>
      </NavItem>
    ))}
  </Nav>
);

export default HpsStatusTabs;
